<form [formGroup]="mainForm">
  <!--    <h1>{{ organizationDetails.OrganizationName }}</h1>-->
  <div class="p-grid p-fluid no-margin">
    <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">
      <label class="registration-label">First Name<sup class="req">*</sup></label>
      <input class="margin-bottom-5" formControlName="firstName" pInputText type="text"/>
      @if (mainForm.get('firstName').dirty && mainForm.get('firstName').errors?.required) {
        <span class="p-error">First Name is required</span>
      }
    </div>
    <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">
      <label class="registration-label">Last Name<sup class="req">*</sup></label>
      <input class="margin-bottom-5" formControlName="lastName" pInputText type="text"/>
      @if (mainForm.get('lastName').dirty && mainForm.get('lastName').errors?.required) {
        <span class="p-error">Last Name is required</span>
      }
    </div>

    <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">
      <label class="registration-label">Email<sup class="req">*</sup></label>
      <!--        <input type="text" class="margin-bottom-5" pInputText formControlName="email"/>-->
      <input class="margin-bottom-5" formControlName="email" pInputText tabindex="0" type="text">
      @if (mainForm.get('email').dirty && mainForm.get('email').errors?.required) {
        <span class="p-error">Email is required</span>
      }
      @if (mainForm.get('email').dirty && mainForm.get('email').errors?.email) {
        <span class="p-error">Valid Email is required</span>
      }
    </div>

    <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">
      <label class="registration-label">Mobile #<sup class="req">*</sup></label>
      <p-inputmask [className]="'form-input no-border'" formControlName="mobile" mask="(999) 999-9999"></p-inputmask>
      @if (mainForm.get('mobile').dirty && mainForm.get('mobile').errors?.required) {
        <span class="p-error">Mobile is required</span>
      }
    </div>
    @if (contextService.contextObject.tenantName && this.personPrefill) {
      <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10 registration-address">
        <app-address-form-custom (outgoingAddress)="setAddress($event)" [canTabWrite]="true" [incomingAddressMailing]="incomingAddressMailing" [showCategory]="true"
                                 [showCounty]="false" [showZipPlus4]="false"></app-address-form-custom>
      </div>
    }
    @if (personPrefill?.PersonProfileClassificationCollect) {
      <div class="col-md-6 col-sm-12 col-xs-12 input-container">
        <app-select (emitData)="setClassificationData($event)" [inputObj]="inputObjClassification" class="full-width">
        </app-select>
      </div>
    }
    @if (personPrefill?.OccupationCollect) {
      <div class="col-md-6 col-sm-12 col-xs-12 input-container">
        <app-select (emitData)="setOccupationData($event)" [inputObj]="inputObjOccupation" class="full-width">
        </app-select>
      </div>
    }
    @if (personPrefill?.EmployerCollect) {
      <div class="col-md-6 col-sm-12 col-xs-12 input-container">
        <app-select (emitData)="setEmployerData($event)" [inputObj]="inputObjEmployer" class="full-width">
        </app-select>
      </div>
    }

    @if (personPrefill?.PersonProfileDuesGroupCollect) {
      <div class="col-md-6 col-sm-12 col-xs-12 input-container">
        <app-select (emitData)="setDuesGroupData($event)" [inputObj]="inputObjDuesGroup" class="full-width">
        </app-select>
      </div>
    }




    <!--      <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">-->
    <!--        <label class="registration-label">Job Title<sup class="req">*</sup></label>-->
    <!--        <input type="text" class="margin-bottom-5" pInputText formControlName="jobTitle"/>-->
    <!--        @if (mainForm.get('jobTitle').dirty && mainForm.get('jobTitle').errors?.required) {-->
    <!--          <span class="p-error">Job Title is required</span>-->
    <!--        }-->
    <!--      </div>-->
    <!--      <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">-->
    <!--        <label class="registration-label">Agency<sup class="req">*</sup></label>-->
    <!--        <input type="text" class="margin-bottom-5" pInputText formControlName="agency"/>-->
    <!--      </div>-->
    <!--      <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">-->
    <!--        <label class="registration-label">Work Location<sup class="req">*</sup></label>-->
    <!--        <input type="text" class="margin-bottom-5" pInputText formControlName="workLocation"/>-->
    <!--        @if (mainForm.get('workLocation').dirty && mainForm.get('workLocation').errors?.required) {-->
    <!--          <span class="p-error">Work Location is required</span>-->
    <!--        }-->
    <!--      </div>-->

    <div class="next-page-button">
      <p-button (click)="goToNextPage()" [disabled]="mainForm.invalid" label="Next"/>
    </div>
  </div>
</form>
